import 'css-chunksrc/client/pages/costProfilesPage/resource/assignCostProfileToResource/selectedProfile/styles.scss';export default {
  "selectedProfile": "_selectedProfile_dkkqj_1",
  "name": "_name_dkkqj_13",
  "cost": "_cost_dkkqj_19",
  "icon": "_icon_dkkqj_25"
};